/**
 * Copyright 2019 Adariz S.R.L. All Rights Reserved.
 */

/* eslint-disable no-console */

import firebase from 'firebase/app'
import 'firebase/firebase-firestore'
import * as constants from '../../../constants.json'
import remDiacritics from 'remove-accents'

export default {

  /**
   * Properties from the app state.
   * @property {array} state.loadedProducts   - Array of product objects fetched from database.
   * @property {object} state.loadedProduct   - Product object fetched from database.
   */
  state: {
    loadedProducts: [],
    loadedProduct: {},
    loadedProductVariations: []
  },

  mutations: {

    /**
     * Mutation method that add a new product object to `state.loadedProducts`.
     * @param {object} state    - The state property.
     * @param {object} payload  - The product object.
     */
    mutationAddNewProduct (state, payload) {
      state.loadedProducts.push(payload)
    },

    /**
     * Mutation method that load all products fetched from database to `state.loadedProducts`.
     * @param {object} state    - The state property.
     * @param {array} payload   - Array of product objects.
     */
    mutationSetLoadedProducts (state, payload) {
      state.loadedProducts = payload
    },

    /**
     * Mutation method that load a single product object to `state.loadedProduct`.
     * @param {object} state    - The state property.
     * @param {object} payload  - The product object.
     */
    mutationLoadSingleProduct (state, payload) {
      state.loadedProduct = payload
    },

    /**
     * Mutation method tha delete a product object from `state.loadedProducts`.
     * @param {object} state    - The state property.
     * @param {string} payload  - The product object Id.
     */
    mutationDeleteLoadedProduct (state, payload) {
      let index = 0

      console.log('payload: ', payload)

      console.log('state.loadedProducts:', state.loadedProducts)

      for (let el of state.loadedProducts) {
        if (el.productId === payload) {
          state.loadedProducts.splice(index, 1)
          break
        }
        index++
      }

      console.log('state.loadedProducts:', state.loadedProducts)
    }
  },

  actions: {

    /**
     * Adding product content to database
     * @param {object} payload - Contains all the product data
     */
    async actionCreateUpdateProduct ({ commit }, payload) {
      // Loading on
      commit('mutationSetLoading', true)
      console.log('payload: ', payload)
      let productRef
      try {
        // Auxiliar object to update the state via mutation
        payload.keywords = payload.keywords.map(keyword => remDiacritics(keyword.toLowerCase()))

        const variationsToIndex = []

        const contentToState = { ...payload }
        contentToState.variations = []

        console.log('contentToState', contentToState)

        const galleryToFirestore = []

        payload.gallery.forEach(el => {
          if (el.imageUrl !== '') {
            galleryToFirestore.push({
              imageUrl: el.imageUrl
            })
          }
        })

        console.log('galleryToFirestore', galleryToFirestore)

        // Auxiliar object to store the data in firestore
        const contentToFirestore = {
          productName: payload.productName,
          alterName1: payload.alterName1,
          alterName2: payload.alterName2,
          status: payload.status,
          shortDescription: payload.shortDescription,
          longDescription: payload.longDescription,
          imageUrl: payload.imageUrl,
          videoUrl: payload.videoUrl,
          pdfUrl: payload.pdfUrl,
          gallery: [...galleryToFirestore],
          attributes: payload.attributes,
          variationsDefault: payload.variationsDefault,
          meta: { ...payload.meta },
          parentCategories: payload.parentCategories,
          categories: payload.categories,
          features: {},
          keywords: {},
          creationDate: payload.creationDate,
          variationsIndex: [],
          type: 'product',
          hasVariations: payload.hasVariations,
          useImagesForVariations: payload.useImagesForVariations,
          id: ''
        }

        // Transforming keywords array into maps to store them in firestore
        payload.keywords.forEach(keyword => {
          contentToFirestore.keywords[keyword] = true
        })

        // Loading flowComponents data to auxiliar object in order to store the flow data in firestore
        const flowToFirestore = { flow: [] }
        flowToFirestore.flow = [...payload.flowComponents]

        console.log('flowToFirestore.flow: ', flowToFirestore.flow)

        // Loading features data to firestore
        payload.features.forEach(el => {
          if (payload.features[0].name === '') {
            contentToFirestore.features['noValue'] = true
          } else if (el.name !== '') {
            contentToFirestore.features[el.name] = el.value
          }
        })

        console.log('contentToFirestore: ', contentToFirestore)

        // Setting product's counter in bot doc.
        // Bot doc reference
        const botRef = firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)

        // Increase value
        const increment = firebase.firestore.FieldValue.increment(1)

        // Decrement value
        const decrement = firebase.firestore.FieldValue.increment(-1)

        // Get a new write batch
        const batch = firebase.firestore().batch()

        // If product doc exists we update the counter if a parent category has been added or changed.
        if (payload.productId) {
          productRef = firebase
            .firestore()
            .collection('companies')
            .doc(payload.companyId)
            .collection('bots')
            .doc(constants.BOT_ID)
            .collection('products')
            .doc(payload.productId)

          contentToState.modificationDate = payload.modificationDate
          contentToFirestore.modificationDate = payload.modificationDate

          // Update the product's counter by category in bot doc.
          const formerLength = payload.formerParentCategories.length
          let index = 0

          // Go through all the parentCategories in payload
          for (const parent of payload.parentCategories) {
            // If the parent category in payload is newer than the db and status has been changed we increase the counter
            // of the new parent category
            const newParentCategoryId = parent.id
            const formerParentCategoryId = payload.formerParentCategories[index].id
            if (index + 1 > formerLength) {
              if (payload.statusChanged) {
                batch.set(botRef, { products: { [newParentCategoryId]: increment } }, { merge: true })
              }
            } else {
              const found = payload.formerParentCategories.indexOf(parent.id)
              // Category Changed = True
              if (found === -1) {
                console.log('Category Changed = True')
                // Status Changed = True
                if (payload.statusChanged) {
                  console.log('Status Changed = True')
                  // Status = Published
                  if (payload.status === 'published') {
                    console.log('Status = Published')
                    if (newParentCategoryId === null) {
                      console.log('newParentCategoryId = null')
                      batch.set(botRef, { products: { 'none': increment } }, { merge: true })
                    } else {
                      console.log('newParentCategoryId != null')
                      batch.set(botRef, { products: { [newParentCategoryId]: increment } }, { merge: true })
                    }
                  // Status != Published
                  } else {
                    console.log('Status != Published')
                    if (formerParentCategoryId === null) {
                      console.log('formerParentCategoryId = null')
                      batch.set(botRef, { products: { 'none': decrement } }, { merge: true })
                    } else {
                      console.log('formerParentCategoryId != null')
                      batch.set(botRef, { products: { [formerParentCategoryId]: decrement } }, { merge: true })
                    }
                  }
                // Status Changed = False
                } else {
                  console.log('Status Changed = False')
                  // Status = Published
                  if (payload.status === 'published') {
                    console.log('Status = Published')
                    if (formerParentCategoryId === null) {
                      console.log('formerParentCategoryId = null')
                      batch.set(botRef, { products: { 'none': decrement } }, { merge: true })
                      batch.set(botRef, { products: { [newParentCategoryId]: increment } }, { merge: true })
                    } else if (formerParentCategoryId !== null) {
                      console.log('formerParentCategoryId != null')
                      batch.set(botRef, { products: { [formerParentCategoryId]: decrement } }, { merge: true })
                      if (newParentCategoryId === null) {
                        console.log('newParentCategoryId = null')
                        batch.set(botRef, { products: { 'none': increment } }, { merge: true })
                      } else {
                        console.log('newParentCategoryId != null')
                        batch.set(botRef, { products: { [newParentCategoryId]: increment } }, { merge: true })
                      }
                    } else {
                      console.log('formerParentCategoryId = something')
                      if (newParentCategoryId === null) {
                        console.log('newParentCategoryId = null')
                        batch.set(botRef, { products: { 'none': increment } }, { merge: true })
                      } else {
                        console.log('newParentCategoryId != null')
                        batch.set(botRef, { products: { [newParentCategoryId]: increment } }, { merge: true })
                      }
                    }
                  }
                  // Status != Published => Nothing
                }
              // Category Changed = False
              } else {
                console.log('Category Changed = False')
                // Status Changed = True
                if (payload.statusChanged) {
                  console.log('// Status Changed = True')
                  // Status = Published
                  if (payload.status === 'published') {
                    console.log('Status = Published')
                    batch.set(botRef, { products: { [formerParentCategoryId]: increment } }, { merge: true })
                  // Status != Published
                  } else {
                    console.log('Status != Published')
                    batch.set(botRef, { products: { [formerParentCategoryId]: decrement } }, { merge: true })
                  }
                } // Status Changed = False => Nothing
                console.log('Status Changed = False => Nothing')
              }
            }
          }

          // Storing variations
          payload.variations.forEach(el => {
            console.log('Storing variations')

            // Transforming keywords array into maps to store them in firestore
            const keywordsObj = {}
            console.log(el.keywords)
            el.keywords.forEach(keyword => {
              keywordsObj[remDiacritics(keyword.toLowerCase())] = true
            })

            const variationRef = firebase
              .firestore()
              .collection('companies')
              .doc(payload.companyId)
              .collection('bots')
              .doc(constants.BOT_ID)
              .collection('products')

            if (el.name !== '') {
              if (el.id !== '') {
                // Pushing the variation's elements
                const variationsToFirestore = {
                  attributes: el.attributes,
                  title: el.title,
                  name: el.name,
                  imageUrl: el.imageUrl,
                  keywords: { ...keywordsObj },
                  meta: el.meta,
                  id: el.id,
                  productId: payload.productId,
                  gallery: el.gallery,
                  type: 'variation'
                }

                contentToState.variations.push({
                  attributes: el.attributes,
                  title: el.title,
                  name: el.name,
                  imageUrl: el.imageUrl,
                  keywords: el.keywords,
                  meta: el.meta,
                  id: el.id,
                  productId: payload.productId,
                  gallery: el.gallery,
                  type: 'variation'
                })

                batch.update(variationRef.doc(el.id), variationsToFirestore)
                console.log('variationsToFirestore: ', variationsToFirestore)

                variationsToIndex.push({
                  keywords: el.keywords,
                  id: el.id
                })
              } else {
                // Pushing the variation's elements
                const newVarDoc = variationRef.doc()

                const variationsToFirestore = {
                  attributes: el.attributes,
                  title: el.title,
                  name: el.name,
                  imageUrl: el.imageUrl,
                  keywords: { ...keywordsObj },
                  meta: el.meta,
                  id: newVarDoc.id,
                  productId: payload.productId,
                  gallery: el.gallery,
                  type: 'variation'
                }

                contentToState.variations.push({
                  attributes: el.attributes,
                  title: el.title,
                  name: el.name,
                  imageUrl: el.imageUrl,
                  keywords: el.keywords,
                  meta: el.meta,
                  id: newVarDoc.id,
                  productId: payload.productId,
                  gallery: el.gallery,
                  type: 'variation'
                })

                batch.set(newVarDoc, variationsToFirestore)
                console.log('variationsToFirestore: ', variationsToFirestore)
                variationsToIndex.push({
                  keywords: el.keywords,
                  id: newVarDoc.id
                })
              }
            }
          })

          // Update product and variation index
          let prodIndexId = payload.productName.slice(0, 2)
          prodIndexId = remDiacritics(prodIndexId.toLowerCase())
          console.log('prodIndexId: ', prodIndexId)

          let formerProdIndexId = payload.formerProductName.slice(0, 2)
          formerProdIndexId = remDiacritics(formerProdIndexId.toLowerCase())
          console.log('formerProdIndexId: ', formerProdIndexId)

          const prodIndexRef = firebase
            .firestore()
            .collection('companies')
            .doc(payload.companyId)
            .collection('bots')
            .doc(constants.BOT_ID)
            .collection('index')
            .doc(prodIndexId)

          if (formerProdIndexId === prodIndexId) {
            // Update product index
            const productIndexDoc = await prodIndexRef.get()
            const prodIndexArray = productIndexDoc.data().index
            console.log('prodIndexArray: ', [...prodIndexArray])

            prodIndexArray[prodIndexArray.findIndex(el => el.id === payload.productId)] = {
              keywords: [...payload.keywords],
              productName: payload.productName,
              id: payload.productId
            }

            // Update variation index
            variationsToIndex.forEach(variation => {
              const index = prodIndexArray.findIndex(el => el.id === variation.id)

              if (index === -1) { // If index doesn't exist
                prodIndexArray.push({
                  keywords: [...variation.keywords],
                  productName: `${payload.productName}, ${variation.name}`,
                  id: variation.id
                })
              } else { // If index exist
                prodIndexArray[index] = {
                  keywords: [...variation.keywords],
                  productName: `${payload.productName}, ${variation.name}`,
                  id: variation.id
                }
              }
            })

            console.log('prodIndexArray: ', [...prodIndexArray])
            batch.set(prodIndexRef, { index: prodIndexArray }, { merge: true })
          } else {
            // Delete former product index
            const formerProdIndexRef = firebase
              .firestore()
              .collection('companies')
              .doc(payload.companyId)
              .collection('bots')
              .doc(constants.BOT_ID)
              .collection('index')
              .doc(formerProdIndexId)

            const formerProdIndexDoc = await formerProdIndexRef.get()
            const formerProdIndexArray = formerProdIndexDoc.data().index

            if (formerProdIndexArray.findIndex(el => el.id === payload.productId) !== -1) {
              formerProdIndexArray.splice(formerProdIndexArray.findIndex(el => el.id === payload.productId), 1)
            }

            variationsToIndex.forEach(variation => {
              if (formerProdIndexArray.findIndex(el => el.id === variation.id) !== -1) {
                formerProdIndexArray.splice(formerProdIndexArray.findIndex(el => el.id === variation.id), 1)
              }
            })

            console.log('formerProdIndexArray: ', [...formerProdIndexArray])
            batch.set(formerProdIndexRef, { index: formerProdIndexArray }, { merge: true })

            // Add to new product index
            const prodIndexDoc = await prodIndexRef.get()

            if (prodIndexDoc.exists) {
              console.log('prodIndexDoc exists')

              const indexArray = prodIndexDoc.data().index

              indexArray.push({
                keywords: [...payload.keywords],
                productName: payload.productName,
                id: payload.productId
              })

              // Add to new variation index
              variationsToIndex.forEach(variation => {
                const index = indexArray.findIndex(el => el.id === variation.id)

                if (index === -1) {
                  indexArray.push({
                    keywords: [...variation.keywords],
                    productName: `${payload.productName}, ${variation.name}`,
                    id: variation.id
                  })
                } else {
                  indexArray[index] = {
                    keywords: [...variation.keywords],
                    productName: `${payload.productName}, ${variation.name}`,
                    id: variation.id
                  }
                }
              })

              batch.set(prodIndexRef, { index: indexArray }, { merge: true })
            } else {
              console.log('prodIndexDoc doesnt exist')

              const indexArray = [{
                keywords: [...payload.keywords],
                productName: payload.productName,
                id: payload.productId
              }]

              // Update variation index
              variationsToIndex.forEach(variation => {
                const index = indexArray.findIndex(el => el.id === variation.id)

                if (index === -1) {
                  indexArray.push({
                    keywords: [...variation.keywords],
                    productName: `${payload.productName}, ${variation.name}`,
                    id: variation.id
                  })
                } else {
                  indexArray[index] = {
                    keywords: [...variation.keywords],
                    productName: `${payload.productName}, ${variation.name}`,
                    id: variation.id
                  }
                }
              })

              console.log('indexArray: ', indexArray)
              batch.set(prodIndexRef, { index: indexArray })
            }
          }

          if (payload.alterName1 !== '') {
            let alterName1IndexId = payload.alterName1.slice(0, 2)
            alterName1IndexId = remDiacritics(alterName1IndexId.toLowerCase())
            console.log('alterName1IndexId: ', alterName1IndexId)

            let formerAlterName1IndexId = payload.formerAlterName1.slice(0, 2)
            formerAlterName1IndexId = remDiacritics(formerAlterName1IndexId.toLowerCase())
            console.log('formerAlterName1IndexId: ', formerAlterName1IndexId)

            const alterName1IndexRef = firebase
              .firestore()
              .collection('companies')
              .doc(payload.companyId)
              .collection('bots')
              .doc(constants.BOT_ID)
              .collection('index')
              .doc(alterName1IndexId)

            if (formerAlterName1IndexId === alterName1IndexId) {
              // Update alterName1 index
              const productAlterName1Doc = await alterName1IndexRef.get()
              const alterName1indexArray = productAlterName1Doc.data().index
              console.log('alterName1indexArray: ', alterName1indexArray)

              alterName1indexArray[alterName1indexArray.findIndex(el => el.id === payload.productId)] = {
                keywords: [...payload.keywords],
                productName: payload.productName,
                id: payload.productId
              }

              // Update variation index
              variationsToIndex.forEach(variation => {
                const index = alterName1indexArray.findIndex(el => el.id === variation.id)

                if (index === -1) {
                  alterName1indexArray.push({
                    keywords: [...variation.keywords],
                    productName: `${payload.productName}, ${variation.name}`,
                    id: variation.id
                  })
                } else {
                  alterName1indexArray[index] = {
                    keywords: [...variation.keywords],
                    productName: `${payload.productName}, ${variation.name}`,
                    id: variation.id
                  }
                }
              })

              console.log('alterName1indexArray: ', alterName1indexArray)
              batch.set(alterName1IndexRef, { index: alterName1indexArray }, { merge: true })
            } else {
              // Delete former alterName1 index
              if (formerAlterName1IndexId !== '') {
                console.log('Deleting former alter name 1 index')
                const formerAlterName1IndexRef = firebase
                  .firestore()
                  .collection('companies')
                  .doc(payload.companyId)
                  .collection('bots')
                  .doc(constants.BOT_ID)
                  .collection('index')
                  .doc(formerAlterName1IndexId)

                const formerAlterName1IndexDoc = await formerAlterName1IndexRef.get()
                const formerAlterName1IndexArray = formerAlterName1IndexDoc.data().index

                if (formerAlterName1IndexArray.findIndex(el => el.id === payload.productId) !== -1) {
                  formerAlterName1IndexArray.splice(formerAlterName1IndexArray.findIndex(el => el.id === payload.productId), 1)
                }

                variationsToIndex.forEach(variation => {
                  if (formerAlterName1IndexArray.findIndex(el => el.id === variation.id) !== -1) {
                    formerAlterName1IndexArray.splice(formerAlterName1IndexArray.findIndex(el => el.id === variation.id), 1)
                  }
                })

                console.log('formerAlterName1IndexArray: ', formerAlterName1IndexArray)
                batch.set(formerAlterName1IndexRef, { index: formerAlterName1IndexArray }, { merge: true })
              }
              // Add to new alterName1 index
              const alterName1IndexDoc = await alterName1IndexRef.get()

              if (alterName1IndexDoc.exists) {
                console.log('alterName1IndexDoc exists')

                const indexArray = alterName1IndexDoc.data().index

                indexArray.push({
                  keywords: [...payload.keywords],
                  productName: payload.productName,
                  id: payload.productId
                })

                // Update variation index
                variationsToIndex.forEach(variation => {
                  const index = indexArray.findIndex(el => el.id === variation.id)

                  if (index === -1) {
                    indexArray.push({
                      keywords: [...variation.keywords],
                      productName: `${payload.productName}, ${variation.name}`,
                      id: variation.id
                    })
                  } else {
                    indexArray[index] = {
                      keywords: [...variation.keywords],
                      productName: `${payload.productName}, ${variation.name}`,
                      id: variation.id
                    }
                  }
                })

                console.log('indexArray: ', indexArray)
                batch.set(alterName1IndexRef, { index: indexArray }, { merge: true })
              } else {
                console.log('alterName1IndexDoc doesnt exist')

                const indexArray = [{
                  keywords: [...payload.keywords],
                  productName: payload.productName,
                  id: payload.productId
                }]

                // Update variation index
                variationsToIndex.forEach(variation => {
                  const index = indexArray.findIndex(el => el.id === variation.id)

                  if (index === -1) {
                    indexArray.push({
                      keywords: [...variation.keywords],
                      productName: `${payload.productName}, ${variation.name}`,
                      id: variation.id
                    })
                  } else {
                    indexArray[index] = {
                      keywords: [...variation.keywords],
                      productName: `${payload.productName}, ${variation.name}`,
                      id: variation.id
                    }
                  }
                })

                console.log('indexArray: ', indexArray)
                batch.set(alterName1IndexRef, { index: indexArray })
              }
            }
          }

          if (payload.alterName2 !== '') {
            let alterName2IndexId = payload.alterName2.slice(0, 2)
            alterName2IndexId = remDiacritics(alterName2IndexId.toLowerCase())
            console.log('alterName2IndexId: ', alterName2IndexId)

            let formerAlterName2IndexId = payload.formerAlterName2.slice(0, 2)
            formerAlterName2IndexId = remDiacritics(formerAlterName2IndexId.toLowerCase())
            console.log('formerAlterName2IndexId: ', formerAlterName2IndexId)

            const alterName2IndexRef = firebase
              .firestore()
              .collection('companies')
              .doc(payload.companyId)
              .collection('bots')
              .doc(constants.BOT_ID)
              .collection('index')
              .doc(alterName2IndexId)

            if (formerAlterName2IndexId === alterName2IndexId) {
              // Update alterName2 index
              const productAlterName2Doc = await alterName2IndexRef.get()
              const alterName2indexArray = productAlterName2Doc.data().index
              console.log('alterName2indexArray: ', alterName2indexArray)

              alterName2indexArray[alterName2indexArray.findIndex(el => el.id === payload.productId)] = {
                keywords: [...payload.keywords],
                productName: payload.productName,
                id: payload.productId
              }

              // Update variation index
              variationsToIndex.forEach(variation => {
                const index = alterName2indexArray.findIndex(el => el.id === variation.id)

                if (index === -1) {
                  alterName2indexArray.push({
                    keywords: [...variation.keywords],
                    productName: `${payload.productName}, ${variation.name}`,
                    id: variation.id
                  })
                } else {
                  alterName2indexArray[index] = {
                    keywords: [...variation.keywords],
                    productName: `${payload.productName}, ${variation.name}`,
                    id: variation.id
                  }
                }
              })

              console.log('alterName2indexArray: ', alterName2indexArray)
              batch.set(alterName2IndexRef, { index: alterName2indexArray }, { merge: true })
            } else {
              // Delete former alterName2 index
              if (formerAlterName2IndexId !== '') {
                console.log('Deleting former alter name 2 index')
                const formerAlterName2IndexRef = firebase
                  .firestore()
                  .collection('companies')
                  .doc(payload.companyId)
                  .collection('bots')
                  .doc(constants.BOT_ID)
                  .collection('index')
                  .doc(formerAlterName2IndexId)

                const formerAlterName2IndexDoc = await formerAlterName2IndexRef.get()
                const formerAlterName2IndexArray = formerAlterName2IndexDoc.data().index

                if (formerAlterName2IndexArray.findIndex(el => el.id === payload.productId) !== -1) {
                  formerAlterName2IndexArray.splice(formerAlterName2IndexArray.findIndex(el => el.id === payload.productId), 1)
                }

                variationsToIndex.forEach(variation => {
                  if (formerAlterName2IndexArray.findIndex(el => el.id === variation.id) !== -1) {
                    formerAlterName2IndexArray.splice(formerAlterName2IndexArray.findIndex(el => el.id === variation.id), 1)
                  }
                })

                console.log('formerAlterName2IndexArray: ', formerAlterName2IndexArray)
                batch.set(formerAlterName2IndexRef, { index: formerAlterName2IndexArray }, { merge: true })
              }

              // Add to new alterName2 index
              const alterName2IndexDoc = await alterName2IndexRef.get()

              if (alterName2IndexDoc.exists) {
                console.log('alterName2IndexDoc exists')
                const indexArray = alterName2IndexDoc.data().index

                indexArray.push({
                  keywords: [...payload.keywords],
                  productName: payload.productName,
                  id: payload.productId
                })

                // Update variation index
                variationsToIndex.forEach(variation => {
                  const index = indexArray.findIndex(el => el.id === variation.id)

                  if (index === -1) {
                    indexArray.push({
                      keywords: [...variation.keywords],
                      productName: `${payload.productName}, ${variation.name}`,
                      id: variation.id
                    })
                  } else {
                    indexArray[index] = {
                      keywords: [...variation.keywords],
                      productName: `${payload.productName}, ${variation.name}`,
                      id: variation.id
                    }
                  }
                })

                console.log('indexArray: ', indexArray)
                batch.set(alterName2IndexRef, { index: indexArray }, { merge: true })
              } else {
                console.log('alterName2IndexDoc doesnt exist')

                const indexArray = [{
                  keywords: [...payload.keywords],
                  productName: payload.productName,
                  id: payload.productId
                }]

                // Update variation index
                variationsToIndex.forEach(variation => {
                  const index = indexArray.findIndex(el => el.id === variation.id)

                  if (index === -1) {
                    indexArray.push({
                      keywords: [...variation.keywords],
                      productName: `${payload.productName}, ${variation.name}`,
                      id: variation.id
                    })
                  } else {
                    indexArray[index] = {
                      keywords: [...variation.keywords],
                      productName: `${payload.productName}, ${variation.name}`,
                      id: variation.id
                    }
                  }
                })

                console.log('indexArray: ', indexArray)
                batch.set(alterName2IndexRef, { index: indexArray })
              }
            }
          }

        // If product doc does not exist we run a batch write and increase the product's counter in bot doc.
        } else {
          console.log('Creating new product')
          productRef = firebase
            .firestore()
            .collection('companies')
            .doc(payload.companyId)
            .collection('bots')
            .doc(constants.BOT_ID)
            .collection('products')
            .doc()

          let keyName

          // For each parent category we add a product counter in bot doc.

          for (const el of payload.parentCategories) {
            if (el.id === '' || el.id === null) {
              keyName = 'none'
            } else {
              keyName = el.id
            }
            if (payload.status === 'published') {
              // Update read count
              batch.set(botRef, { products: { [keyName]: increment } }, { merge: true })
            }
          }

          // Loading variations data to auxiliar object in order to store them in firestore
          payload.variations.forEach(el => {
          // Transforming keywords array into maps to store them in firestore
            const keywordsObj = {}
            el.keywords.forEach(keyword => {
              keywordsObj[remDiacritics(keyword.toLowerCase())] = true
            })

            const variationRef = firebase
              .firestore()
              .collection('companies')
              .doc(payload.companyId)
              .collection('bots')
              .doc(constants.BOT_ID)
              .collection('products')

            if (el.name !== '') {
              const newVarDoc = variationRef.doc()
              // Pushing the variation elements and creating the ids
              const variationsToFirestore = {
                attributes: el.attributes,
                title: el.title,
                name: el.name,
                imageUrl: el.imageUrl,
                keywords: { ...keywordsObj },
                meta: el.meta,
                id: newVarDoc.id,
                productId: productRef.id,
                gallery: el.gallery,
                type: 'variation'
              }

              contentToState.variations.push({
                attributes: el.attributes,
                title: el.title,
                name: el.name,
                imageUrl: el.imageUrl,
                keywords: el.keywords,
                meta: el.meta,
                id: newVarDoc.id,
                productId: productRef.id,
                gallery: el.gallery,
                type: 'variation'
              })

              batch.set(newVarDoc, variationsToFirestore)
              console.log('variationsToFirestore: ', variationsToFirestore)

              variationsToIndex.push({
                keywords: el.keywords,
                id: newVarDoc.id
              })
            }
          })

          // Create product index
          let prodIndexId = payload.productName.slice(0, 2)
          prodIndexId = remDiacritics(prodIndexId.toLowerCase())

          const prodIndexRef = firebase
            .firestore()
            .collection('companies')
            .doc(payload.companyId)
            .collection('bots')
            .doc(constants.BOT_ID)
            .collection('index')
            .doc(prodIndexId.toLowerCase())

          console.log('prodIndexId: ', prodIndexId.toLowerCase())

          // Set product index
          const prodIndexDoc = await prodIndexRef.get()

          if (prodIndexDoc.exists) {
            console.log('product index exist')

            const indexArray = prodIndexDoc.data().index

            indexArray.push({
              keywords: [...payload.keywords],
              productName: payload.productName,
              id: productRef.id
            })

            variationsToIndex.forEach(variation => {
              indexArray.push({
                keywords: [...variation.keywords],
                productName: `${payload.productName}, ${variation.name}`,
                id: variation.id
              })
            })

            console.log('indexArray: ', indexArray)
            batch.set(prodIndexRef, { index: indexArray }, { merge: true })
          } else {
            console.log('creating new product index')
            const indexArray = [{
              keywords: [...payload.keywords],
              productName: payload.productName,
              id: productRef.id
            }]

            variationsToIndex.forEach(variation => {
              indexArray.push({
                keywords: [...variation.keywords],
                productName: `${payload.productName}, ${variation.name}`,
                id: variation.id
              })
            })

            console.log('indexArray: ', indexArray)
            batch.set(prodIndexRef, { index: indexArray })
          }

          // Set alterName 1 index
          if (payload.alterName1 !== '') {
            let alterName1IndexId = payload.alterName1.slice(0, 2)
            alterName1IndexId = remDiacritics(alterName1IndexId.toLowerCase())

            console.log('alterName1IndexId: ', alterName1IndexId.toLowerCase())

            const alterName1IndexRef = firebase
              .firestore()
              .collection('companies')
              .doc(payload.companyId)
              .collection('bots')
              .doc(constants.BOT_ID)
              .collection('index')
              .doc(alterName1IndexId.toLowerCase())

            const alterName1IndexDoc = await alterName1IndexRef.get()

            if (alterName1IndexDoc.exists) {
              console.log('alterName1IndexDoc exists')

              const indexArray = alterName1IndexDoc.data().index

              indexArray.push({
                keywords: [...payload.keywords],
                productName: payload.productName,
                id: productRef.id
              })

              variationsToIndex.forEach(variation => {
                indexArray.push({
                  keywords: [...variation.keywords],
                  productName: `${payload.productName}, ${variation.name}`,
                  id: variation.id
                })
              })

              console.log('indexArray: ', indexArray)
              batch.set(alterName1IndexRef, { index: indexArray }, { merge: true })
            } else {
              console.log('alterName1IndexDoc doesnt exist')

              const indexArray = [{
                keywords: [...payload.keywords],
                productName: payload.productName,
                id: productRef.id
              }]

              console.log('variationsToIndex: ', variationsToIndex)
              variationsToIndex.forEach(variation => {
                indexArray.push({
                  keywords: [...variation.keywords],
                  productName: `${payload.productName}, ${variation.name}`,
                  id: variation.id
                })
              })

              console.log('indexArray: ', indexArray)
              batch.set(alterName1IndexRef, { index: indexArray })
            }
          }

          // Set alterName 2 index
          if (payload.alterName2 !== '') {
            let alterName2IndexId = payload.alterName2.slice(0, 2)
            alterName2IndexId = remDiacritics(alterName2IndexId.toLowerCase())

            console.log('alterName2IndexId: ', alterName2IndexId.toLowerCase())

            const alterName2IndexRef = firebase
              .firestore()
              .collection('companies')
              .doc(payload.companyId)
              .collection('bots')
              .doc(constants.BOT_ID)
              .collection('index')
              .doc(alterName2IndexId.toLowerCase())

            const alterName2IndexDoc = await alterName2IndexRef.get()

            if (alterName2IndexDoc.exists) {
              console.log('alterName2IndexDoc exists')

              const indexArray = alterName2IndexDoc.data().index

              indexArray.push({
                keywords: [...payload.keywords],
                productName: payload.productName,
                id: productRef.id
              })

              variationsToIndex.forEach(variation => {
                indexArray.push({
                  keywords: [...variation.keywords],
                  productName: `${payload.productName}, ${variation.name}`,
                  id: variation.id
                })
              })

              console.log('indexArray: ', indexArray)
              batch.set(alterName2IndexRef, { index: indexArray }, { merge: true })
            } else {
              console.log('alterName2IndexDoc doesnt exist')

              const indexArray = [{
                keywords: [...payload.keywords],
                productName: payload.productName,
                id: productRef.id
              }]

              variationsToIndex.forEach(variation => {
                indexArray.push({
                  keywords: [...variation.keywords],
                  productName: `${payload.productName}, ${variation.name}`,
                  id: variation.id
                })
              })

              console.log('indexArray: ', indexArray)
              batch.set(alterName2IndexRef, { index: indexArray })
            }
          }
        }

        // -------Storing data on firebase-------

        // Set the contentToFirestore values to write batch in firestore.
        console.log('productRef.id: ', productRef.id)
        contentToFirestore.id = productRef.id
        contentToState.productId = productRef.id
        batch.set(productRef, contentToFirestore)

        // Set the flowToFirestore values
        batch.set(productRef.collection('flows').doc('1'), flowToFirestore)

        // Committing batch write
        await batch.commit()

        // Mutating state
        commit('mutationAddNewProduct', contentToState)

        // Loading off
        commit('mutationSetLoading', false)

        return contentToState
      } catch (error) {
        commit('mutationSetLoading', false)
        throw error
      }
    },

    /**
     * Loading all products from database
     * @param {object} payload - Contains companyId.
     */
    async actionLoadProducts ({ commit }, payload) {
      const products = []

      // Loading on
      commit('mutationSetLoading', true)
      try {
        // Get all products from firestore
        const productRef = firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)
          .collection('products')

        const queryProducts = await productRef
          .where('type', '==', 'product')
          .orderBy('productName')
          .get()

        console.log('payload: ', payload)
        // Load products to state
        queryProducts.docs.forEach(async product => {
          let variationDefaultImage = ''
          if (product.data().hasVariations) {
            const variationDefault = await productRef
              .where('productId', '==', product.id)
              .where('name', '==', product.data().variationsDefault)
              .get()

            variationDefaultImage = variationDefault.docs[0].data().imageUrl
          }
          products.push({
            productName: product.data().productName,
            alterName1: product.data().alterName1,
            alterName2: product.data().alterName2,
            status: product.data().status,
            shortDescription: product.data().shortDescription,
            imageUrl: product.data().imageUrl === '' ? variationDefaultImage : product.data().imageUrl,
            flowComponents: [],
            attributes: product.data().attributes,
            variations: [],
            variationsDefault: product.data().variationsDefault,
            meta: { ...product.data().meta },
            parentCategories: product.data().parentCategories,
            categories: product.data().categories,
            creationDate: product.data().creationDate,
            modificationDate: product.data().modificationDate,
            productId: product.id
          })
        })
        commit('mutationSetLoadedProducts', products)
        // Activate new toolbar
        commit('mutationSetNewToolbar', true)

        // Loading off
        commit('mutationSetLoading', false)
      } catch (error) {
        commit('mutationSetLoading', false)
        throw error
      }
    },

    /**
     * Loading single product data
     * @param {object} payload -Contains companyId and productId
     */
    async actionLoadSingleProduct ({ commit }, payload) {
      // Loading on
      commit('mutationSetLoading', true)

      try {
        // Get product doc from firebase
        const productRef = firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)
          .collection('products')
          .doc(payload.productId)
        const queryProduct = await productRef.get()

        // Load auxiliar object with the product data
        const productObj = {
          productName: queryProduct.data().productName,
          alterName1: queryProduct.data().alterName1,
          alterName2: queryProduct.data().alterName2,
          status: queryProduct.data().status,
          shortDescription: queryProduct.data().shortDescription,
          longDescription: queryProduct.data().longDescription,
          imageUrl: queryProduct.data().imageUrl,
          videoUrl: queryProduct.data().videoUrl,
          pdfUrl: queryProduct.data().pdfUrl,
          mainImage: '',
          gallery: [],
          flowComponents: [],
          attributes: queryProduct.data().attributes,
          variations: [],
          variationsDefault: queryProduct.data().variationsDefault,
          meta: { ...queryProduct.data().meta },
          parentCategories: queryProduct.data().parentCategories,
          categories: queryProduct.data().categories,
          features: [],
          keywords: [],
          creationDate: queryProduct.data().creationDate,
          modificationDate: queryProduct.data().modificationDate,
          hasVariations: queryProduct.data().hasVariations,
          useImagesForVariations: queryProduct.data().useImagesForVariations,
          productId: queryProduct.id
        }
        // Transforming keywords maps into an array

        for (let key in queryProduct.data().keywords) {
          productObj.keywords.push(key)
        }
        // Loading gallery's data
        const gallery = []
        queryProduct.data().gallery.forEach(el => {
          gallery.push({
            imageUrl: el.imageUrl
          })
        })

        // Loading flow's data
        const flows = []
        const queryFlows = await productRef.collection('flows').doc('1').get()

        queryFlows.data().flow.forEach((el1, index1) => {
          flows.push({
            selectContentType: el1.selectContentType,
            description: el1.description,
            image: '',
            video: '',
            gallery: [],
            keywords: el1.keywords,
            imageUrl: el1.imageUrl,
            videoUrl: el1.videoUrl,
            title: el1.title,
            showOnWeb: el1.showOnWeb
          })
          if (el1.selectContentType === 'Galería') {
            el1.gallery.forEach(el2 => {
              flows[index1].gallery.push({
                image: '',
                imageUrl: el2.imageUrl,
                title: el2.title,
                subtitle: el2.subtitle
              })
            })
          }
        })

        // Loading variation's data
        const variations = []
        const queryVariations = await firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)
          .collection('products')
          .where('type', '==', 'variation')
          .where('productId', '==', payload.productId)
          .orderBy('name')
          .get()

        if (queryVariations.empty) {
          variations.push({
            attributes: [],
            name: '',
            title: '',
            gallery: [],
            productId: '',
            type: 'variation',
            image: '',
            imageUrl: '',
            keywords: [],
            meta: {
              barcode: '',
              height: '',
              length: '',
              regularPrice: 0,
              salePrice: 0,
              sku: '',
              stock: 0,
              stockStatus: '',
              variationDescription: '',
              weight: '',
              width: ''
            },
            id: ''
          })
        } else {
          queryVariations.docs.forEach(variation => {
            const variationAux = []

            for (let key in variation.data().keywords) {
              variationAux.push(key)
            }
            variations.push({
              attributes: variation.data().attributes,
              name: variation.data().name,
              title: variation.data().title,
              gallery: variation.data().gallery,
              productId: variation.data().productId,
              type: variation.data().type,
              image: '',
              imageUrl: variation.data().imageUrl,
              keywords: [...variationAux],
              meta: { ...variation.data().meta },
              id: variation.data().id
            })
          })
        }

        // Trasnforming features map into an array of objects
        const features = []

        for (let key in queryProduct.data().features) {
          if (key === 'noValue') {
            features.push({
              name: '',
              value: ''
            })
          } else {
            features.push({
              name: key,
              value: queryProduct.data().features[key]
            })
          }
        }

        // Loading all products data to state
        productObj.gallery = gallery
        productObj.flowComponents = flows
        productObj.variations = variations
        productObj.features = [...features]

        console.log('features: ', features)

        console.log('productObj: ', productObj)
        commit('mutationLoadSingleProduct', productObj)

        // Activating new toolbar
        commit('mutationSetNewToolbar', true)

        // Loading off
        commit('mutationSetLoading', false)
      } catch (error) {
        commit('mutationSetLoading', false)
        throw error
      }
    },

    /**
     * Delete product
     * @param {object} payload -Contains companyId and productId
     */
    async actionDeleteProduct ({ commit }, payload) {
      console.log('Deleting product: ', payload)
      try {
        const productRef = firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)
          .collection('products')

        const botRef = firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)

        // Update the state
        commit('mutationDeleteLoadedProduct', payload.productId)

        // Get a new batch to delete the document and update the bot count for products
        const batch = firebase.firestore().batch()

        // Decreasing product's counter in bot doc counter and setting to batch

        for (const el of payload.parentCategories) {
          let keyName
          const decrement = firebase.firestore.FieldValue.increment(-1)
          if (el.id !== '' && el.id !== null) {
            keyName = el.id
            if (payload.status === 'published') {
              batch.set(botRef, { products: { [keyName]: decrement } }, { merge: true })
            }
          }
        }

        // Delete the product doc and dependencies
        batch.delete(productRef.doc(payload.productId))
        batch.delete(productRef.doc(payload.productId).collection('flows').doc('1'))

        // Get variationsId to be deleted
        const variations = await productRef
          .where('type', '==', 'variation')
          .where('productId', '==', payload.productId)
          .orderBy('name')
          .get()

        console.log('variations.docs: ', variations.docs)
        variations.docs.forEach(variation => {
          batch.delete(productRef.doc(variation.id))
        })

        // Deleting product index
        console.log('Deleting product index')
        let prodIndexId = payload.productName.slice(0, 2)
        prodIndexId = remDiacritics(prodIndexId.toLowerCase())

        const prodIndexRef = firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)
          .collection('index')
          .doc(prodIndexId)

        const doc = await prodIndexRef.get()
        const indexArray = doc.data().index
        console.log('indexArray: ', indexArray)

        const index = indexArray.findIndex(el => el.id === payload.productId)
        if (index !== -1) indexArray.splice(index, 1)

        // Deleting variations index
        variations.docs.forEach(variation => {
          const index = indexArray.findIndex(el => el.id === variation.id)
          if (index !== -1) indexArray.splice(index, 1)
          if (index !== -1) console.log('Deleting variation index id: ', variation.id)
        })

        batch.update(prodIndexRef, { index: indexArray })

        // Deleting alterName1 index
        if (payload.alterName1 !== '') {
          let alterName1Index = payload.alterName1.slice(0, 2)
          alterName1Index = remDiacritics(alterName1Index.toLowerCase())
          console.log('Deleting alterName1 index: ', alterName1Index)

          const alterName1IndexRef = firebase
            .firestore()
            .collection('companies')
            .doc(payload.companyId)
            .collection('bots')
            .doc(constants.BOT_ID)
            .collection('index')
            .doc(alterName1Index)

          const alterName1IndexDoc = await alterName1IndexRef.get()

          if (alterName1IndexDoc.exists) {
            console.log('alterName1IndexDoc.data().index: ', alterName1IndexDoc.data().index)
            const indexArray = alterName1IndexDoc.data().index
            const index = indexArray.findIndex(el => el.id === payload.productId)
            if (index !== -1) indexArray.splice(index, 1)

            // Deleting variations index
            variations.docs.forEach(variation => {
              const index = indexArray.findIndex(el => el.id === variation.id)
              if (index !== -1) indexArray.splice(index, 1)
              if (index !== -1) console.log('Deleting variation index id: ', variation.id)
            })

            batch.update(alterName1IndexRef, { index: indexArray })
          }
        }
        // Deleting alterName2 index
        if (payload.alterName2 !== '') {
          let alterName2Index = payload.alterName2.slice(0, 2)
          alterName2Index = remDiacritics(alterName2Index.toLowerCase())
          console.log('Deleting alterName2 index: ', alterName2Index)

          const alterName2IndexRef = firebase
            .firestore()
            .collection('companies')
            .doc(payload.companyId)
            .collection('bots')
            .doc(constants.BOT_ID)
            .collection('index')
            .doc(alterName2Index)

          const alterName2IndexDoc = await alterName2IndexRef.get()

          if (alterName2IndexDoc.exists) {
            console.log('alterName2IndexDoc.data().index: ', alterName2IndexDoc.data().index)
            const indexArray = alterName2IndexDoc.data().index
            const index = indexArray.findIndex(el => el.id === payload.productId)
            if (index !== -1) indexArray.splice(index, 1)

            // Deleting variations index
            variations.docs.forEach(variation => {
              const index = indexArray.findIndex(el => el.id === variation.id)
              if (index !== -1) indexArray.splice(index, 1)
              if (index !== -1) console.log('Deleting variation index id: ', variation.id)
            })

            batch.update(alterName2IndexRef, { index: indexArray })
          }
        }

        // Commiting batch write
        await batch.commit()

        console.log('Product deleted')
      } catch (error) {
        throw error
      }
    },

    /**
     * Delete Variation
     * @param {object} payload - Contains companyId, productId and variationId
     */
    async actionDeleteVariation ({ commit }, payload) {
      try {
        // Get variation ref
        const variationRef = firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)
          .collection('products')
          .doc(payload.variationId)

        console.log('variationRef', variationRef)
        // Delete variation
        await variationRef.delete()

        console.log('Variation deleted')
      } catch (error) {
        throw error
      }
    }

  },

  getters: {
    /**
     * @returns an array of products loaded to the state.
     */
    getLoadedProducts (state) {
      return state.loadedProducts
    },

    /**
     * @returns all product data loaded to the state.
     */
    getLoadedSingleProduct (state) {
      return state.loadedProduct
    }
  }
}
